// extracted by mini-css-extract-plugin
module.exports = {"s885v2g":"s885v2g","s95hd2":"s95hd2","title":"title","social-icon":"social-icon"};